/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { getTestDriver, TestElement } from '@oracle/oraclejet-testing/UNSAFE_Driver';
import { byCss } from '@oracle/oraclejet-testing/UNSAFE_Locators';

/**
 * Performs a click action on a legend item.
 * @param {number | string} id
 * @param {TestElement} legendElement
 */
export const doItemAction = async (
  id: number | string,
  legendElement: TestElement
): Promise<void> => {
  const driver = getTestDriver();
  const itemElement = await legendElement.waitForElement(
    byCss(`[data-oj-private-item-id="${id}"]`)
  );
  await driver.click(itemElement);
};
